import * as angular from "angular";

export class TalkingPointService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/talkingpoint";
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.tpid, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.tpid, data);
    }
}

angular
    .module("vcServices")
    .service("TalkingPointService", TalkingPointService);
